const ORG_CONFIG_TYPES = {
  numeric: 'numeric',
  boolean: 'boolean',
  selector: 'selector',
};

module.exports = {
  maxProviderAP: {
    key: 'maxProviderAP',
    label: 'Max Admin Providers',
    type: ORG_CONFIG_TYPES.numeric,
  },
  maxProviderLP: {
    key: 'maxProviderLP',
    label: 'Max Providers',
    type: ORG_CONFIG_TYPES.numeric,
  },
  isSecureLinkEnabled: {
    key: 'isSecureLinkEnabled',
    label: 'Secure Link Enabled',
    type: ORG_CONFIG_TYPES.boolean,
  },
  isConferenceRoomEnabled: {
    key: 'isConferenceRoomEnabled',
    label: 'Conference Room Enabled',
    type: ORG_CONFIG_TYPES.boolean,
  },
  isConferenceRoomTranscribeEnabled: {
    key: 'isConferenceRoomTranscribeEnabled',
    label: 'Conference Room Transcribe Enabled',
    type: ORG_CONFIG_TYPES.boolean,
  },
  isConferenceRoomSummarizeEnabled: {
    key: 'isConferenceRoomSummarizeEnabled',
    label: 'Conference Room Summarize Enabled',
    type: ORG_CONFIG_TYPES.boolean,
  },
  isDictationTranscribeEnabled: {
    key: 'isDictationTranscribeEnabled',
    label: 'Dictation Transcribe Enabled',
    type: ORG_CONFIG_TYPES.boolean,
  },
  isDictationSummarizeEnabled: {
    key: 'isDictationSummarizeEnabled',
    label: 'Dictation Summarize Enabled',
    type: ORG_CONFIG_TYPES.boolean,
  },
  // Computationally expensive
  // isWorkspaceEnabled: {
  // key: 'isWorkspaceEnabled',
  // label: 'Workspace Enabled',
  // type: ORG_CONFIG_TYPES.boolean,
  // },
  isPatientAccountEnabled: {
    key: 'isPatientAccountEnabled',
    label: 'Patient Account Enabled',
    type: ORG_CONFIG_TYPES.boolean,
  },
  isLibraryEnabled: {
    key: 'isLibraryEnabled',
    label: 'Library Enabled',
    type: ORG_CONFIG_TYPES.boolean,
  },
  isAIAnalysisEnabled: {
    key: 'isAIAnalysisEnabled',
    label: 'AI Analysis Enabled',
    type: ORG_CONFIG_TYPES.boolean,
  },
  isHideGenderIdentity: {
    key: 'isHideGenderIdentity',
    label: 'Gender Identity Hidden',
    type: ORG_CONFIG_TYPES.boolean,
  },
  isUnitDefaultMetric: {
    key: 'isUnitDefaultMetric',
    label: 'Default Metric (On) Imperial (Off) Units',
    type: ORG_CONFIG_TYPES.boolean,
  },
  isUserPinRequired: {
    key: 'isUserPinRequired',
    label: 'User Pin Required',
    type: ORG_CONFIG_TYPES.boolean,
  },
  supportedConditions: {
    key: 'supportedConditions',
    label: 'Supported Conditions',
    type: ORG_CONFIG_TYPES.selector,
  },
};